export type CanvasImageSource = string | HTMLImageElement;

export enum CanvasImageEffectName {
	Reveal = 'reveal',
	Transfer = 'transfer'
}

export type CanvasImageScene = {
	containerAfterTransfer: HTMLElement;
	image: CanvasImageSource;
	initialContainer: HTMLElement;
};

export type Rect = {
	height: number;
	width: number;
	x: number;
	y: number;
};

export type CanvasImageTransferBlock = {
	arcHeight: number;
	blockSize: number;
	delay: number;
	duration: number;
	rotationSpeed: number;
	scaleBoost: number;
	sign: number;
	sourceX: number;
	sourceY: number;
	targetX: number;
	targetY: number;
};

export type CanvasImageAsset = {
	detailCanvas: HTMLCanvasElement;
	image: HTMLImageElement;
	offscreenCanvas: HTMLCanvasElement;
	revealCanvas: HTMLCanvasElement;
	sourceRect: Rect;
};

export type CanvasImageTransferData = {
	blocks: CanvasImageTransferBlock[];
	renderedCanvas: HTMLCanvasElement;
};

export type RenderRevealOptions = {
	asset: CanvasImageAsset;
	centerX: number;
	centerY: number;
	imageHeight: number;
	imageWidth: number;
	progress: number;
	stageHeight: number;
	stageWidth: number;
};

export type RenderTransferOptions = {
	centerY: number;
	imageHeight: number;
	imageWidth: number;
	progress: number;
	settledImageOpacity?: number;
	stageHeight: number;
	stageWidth: number;
	startCenterX: number;
	transferData: CanvasImageTransferData;
};

export type SceneGeometry = {
	finalCenterX: number;
	initialCenterX: number;
	initialCenterY: number;
	initialHeight: number;
	initialWidth: number;
	stageHeight: number;
	stageWidth: number;
};

export type CanvasImageTransferDataParams = {
	centerY: number;
	endCenterX: number;
	image: HTMLImageElement;
	imageHeight: number;
	imageWidth: number;
	sourceRect: Rect;
	startCenterX: number;
};

export type CanvasImageTransferCacheParams = {
	asset: CanvasImageAsset;
	finalCenterX: number;
	imageHeight: number;
	imageWidth: number;
	initialCenterX: number;
	initialCenterY: number;
};
